import Vue from 'vue';

Vue.mixin({
  methods: {
    headTitle(title = null) {
      let headTitle = this.$store.getters.CORE_PARAMS &&
      this.$store.getters.CORE_PARAMS.title
          ? this.$store.getters.CORE_PARAMS.title
          : process.env.VUE_APP_TITLE;

      if (title) {
        headTitle += ` ${process.env.VUE_APP_TITLE_SEPARATOR} ${title}`;
      }

      return headTitle;
    },
  },
});

